import { getAllData } from "../../services/ApiCallingUserServices";
import { isNullable } from "../commonClass/CommonValidation";

//#region retrive API
export const getactivitymanagebyid = async (ActivityManageId = 0, cityList = []) => {
    if (ActivityManageId > 0) {
        const activitymanagebyid = await getAllData(`/master/v1/getactivitymanagebyid?ActivityManageId=${ActivityManageId}`);
        if (activitymanagebyid?.status) {

            const basicInfo = activitymanagebyid?.data?.basicInfo?.[0]
            const BasicInformationForm = {
                ActivityBasicInfoId: basicInfo?.ActivityBasicInfoId ? basicInfo?.ActivityBasicInfoId : 0,
                SupplierId: basicInfo?.SupplierId ? basicInfo?.SupplierId : 0,
                CollectionId: basicInfo?.CollectionId ? basicInfo?.CollectionId : 0,
                CategoryId: basicInfo?.CategoryId ? basicInfo?.CategoryId : 0,
                ActivityId: basicInfo?.ActivityId ? basicInfo?.ActivityId : 0,
                ShortDescriptions: basicInfo?.ShortDescriptions ? basicInfo?.ShortDescriptions : "",
                LongDescriptions: basicInfo?.LongDescriptions ? basicInfo?.LongDescriptions : "",
                Highlights: basicInfo?.Highlights ? basicInfo?.Highlights : "",
                IsActive: basicInfo?.IsActive,
            }

            const activityPointAddress = activitymanagebyid?.data?.activityAddress?.[0];
            const meetingPointAddress = activitymanagebyid?.data?.activityAddress?.[1];
            const activityStateId = cityList?.find((prev) => prev?.value === activityPointAddress?.LocationId)?.StateId || 0;
            const meetingStateId = cityList?.find((prev) => prev?.value === meetingPointAddress?.LocationId)?.StateId || 0;
            const PointAddressForm = {
                IsMeetingPointSameAsActivityAddress: basicInfo?.IsMeetingPointSameAsActivityAddress ? basicInfo?.IsMeetingPointSameAsActivityAddress : false,
                ActivityBasicInfoAddress: [
                    {
                        ActivityManageAddressId: activityPointAddress?.ActivityManageAddressId ? activityPointAddress?.ActivityManageAddressId : 0,
                        StateId: activityStateId ? activityStateId : 0,
                        LocationId: activityPointAddress?.LocationId ? activityPointAddress?.LocationId : 0,
                        PinCode: activityPointAddress?.PinCode ? activityPointAddress?.PinCode : "",
                        Landmark: activityPointAddress?.Landmark ? activityPointAddress?.Landmark : "",
                        Latitude: activityPointAddress?.Latitude ? activityPointAddress?.Latitude : "",
                        Longitude: activityPointAddress?.Longitude ? activityPointAddress?.Longitude : "",
                        AddressLine: activityPointAddress?.AddressLine ? activityPointAddress?.AddressLine : "",
                        IsActivePointAddress: true
                    },
                    {
                        ActivityManageAddressId: meetingPointAddress?.ActivityManageAddressId ? meetingPointAddress?.ActivityManageAddressId : 0,
                        StateId: meetingStateId ? meetingStateId : 0,
                        LocationId: meetingPointAddress?.LocationId ? meetingPointAddress?.LocationId : 0,
                        PinCode: meetingPointAddress?.PinCode ? meetingPointAddress?.PinCode : "",
                        Landmark: meetingPointAddress?.Landmark ? meetingPointAddress?.Landmark : "",
                        Latitude: meetingPointAddress?.Latitude ? meetingPointAddress?.Latitude : "",
                        Longitude: meetingPointAddress?.Longitude ? meetingPointAddress?.Longitude : "",
                        AddressLine: meetingPointAddress?.AddressLine ? meetingPointAddress?.AddressLine : "",
                        MobileNo: meetingPointAddress?.MobileNo ? meetingPointAddress?.MobileNo : "",
                        EmailId: meetingPointAddress?.EmailId ? meetingPointAddress?.EmailId : "",
                        IsActivePointAddress: false
                    }
                ]
            }

            const PickUpDropPointXML = activitymanagebyid?.data?.pickupPointDropPoint?.map(({ ActivityBasicInfoId, ...rest }, index) => {
                rest.SeqNo = index + 1;
                return rest;
            }) || [];

            const whatYouGetKeys = ["Inclusion", "Exclusion", "ThingsToAvoid", "ThingsToCarried", "OtherInfo"];
            const WhatYouGetList = whatYouGetKeys?.reduce((acc, keyName) => {
                const data = activitymanagebyid?.data?.activityRuleDetail?.[keyName]?.map(({ ruleType, ...rest }, index) => {
                    rest.SeqNo = index + 1;
                    rest.ActivityRuleDetailId = rest?.activityRuleDetailId;
                    rest.RuleDetails = rest?.ruleDetails;
                    return rest;
                }) || [];
                acc = { ...acc, [keyName]: data };
                return acc;
            }, {})

            const activityInfo = {
                ...activitymanagebyid.data.activityInfo?.[0],
                ActivityName: basicInfo.ActivityName,
                InfoImageList: activitymanagebyid?.data?.activityInfoImageList
            }
            const activityInfoInclusion = activitymanagebyid.data.activityInfoInclusion;

            const activityManagePricing = activitymanagebyid?.data?.activityManagePricing?.[0];
            const commonPricingData = activityManagePricing;
            const ActivityValidity = {
                ValidityFromDate: activityManagePricing?.validityFromDate || null,
                ValidityToDate: activityManagePricing?.validityToDate || null,
            }
            const NonOperatingDateTime = {
                IsNonOperatingDates: activityManagePricing?.isNonOperatingDates || false,
                NonOperatingFromDate: activityManagePricing?.nonOperatingFromDate || null,
                NonOperatingToDate: activityManagePricing?.nonOperatingToDate || null,
                NonOperatingTime: activityManagePricing?.nonOperatingTime || "00:00:00",
            }
            const BookingCutOff = {
                BookingCutoffDays: activityManagePricing?.bookingCutoffDays || null,
                BookingCutoffTime: activityManagePricing?.bookingCutoffTime || "00:00:00"
            }
            const IsScheduleActivity = activityManagePricing?.isScheduleActivity || false;
            const ActivityManageSlots = activityManagePricing?.activityManageSlots?.map((obj, index) => {
                obj.SeqNo = index + 1;
                obj.StartTime = obj?.startTime
                obj.EndTime = obj?.endTime
                obj.OperatedDayId = obj?.operatedDayId
                return obj;
            }) || [];
            const PricingForm = {
                PricingTypeId: activityManagePricing?.pricingTypeId || 0,
                ActivityManagePaxTypeId: activityManagePricing?.activityManagePaxTypeId || 0,
                IsGroupCapacity: activityManagePricing?.isGroupCapacity || false,
                // MaximumPersonCapacity: activityManagePricing?.maximumPersonCapacity ?? null,
            }

            const AdultPricing = activityManagePricing?.paxPricedetails?.find((prev) => prev?.activityManagePaxTypeId === 1) || {};
            const ChildPricing = activityManagePricing?.paxPricedetails?.find((prev) => prev?.activityManagePaxTypeId === 2) || {};
            const GroupPricing = activityManagePricing?.paxPricedetails?.find((prev) => prev?.activityManagePaxTypeId === 3) || {};
            const UserPricingForm = {
                adult: {
                    ActivityManagePaxTypeId: AdultPricing?.activityManagePaxTypeId ?? null,
                    BasePrice: AdultPricing?.basePrice ?? null,
                    ActivityManageTaxId: AdultPricing?.activityManageTaxId || 0,
                    Commission: AdultPricing?.commission ?? null,
                    ETMMarkup: AdultPricing?.etmMarkup ?? null
                },
                child: {
                    ActivityManagePaxTypeId: ChildPricing?.activityManagePaxTypeId ?? null,
                    BasePrice: ChildPricing?.basePrice ?? null,
                    ActivityManageTaxId: ChildPricing?.activityManageTaxId || 0,
                    Commission: ChildPricing?.commission ?? null,
                    ETMMarkup: ChildPricing?.etmMarkup ?? null
                },
                Group: {
                    ActivityManagePaxTypeId: GroupPricing?.activityManagePaxTypeId ?? null,
                    BasePrice: GroupPricing?.basePrice ?? null,
                    ActivityManageTaxId: GroupPricing?.activityManageTaxId || 0,
                    Commission: GroupPricing?.commission ?? null,
                    ETMMarkup: GroupPricing?.etmMarkup ?? null,
                    MaximumPersonCapacity: GroupPricing?.maximumPersonCapacity ?? null
                },
            }

            const CancellationPolicy = activityManagePricing?.activityCancellationPolicy;
            const ActivityCancellationPolicy = {
                ActivityManagePolicyTypeId: CancellationPolicy?.activityManagePolicyTypeId || 0,
                ActivityManageCurrentStatusId: CancellationPolicy?.activityManageCurrentStatusId || 0,
                NoShow: CancellationPolicy?.noShow ?? null,
                UpTo24Hrs: CancellationPolicy?.upTo24Hrs ?? null,
                UpTo48Hrs: CancellationPolicy?.upTo48Hrs ?? null,
                MoreThan48Hrs: CancellationPolicy?.moreThan48Hrs ?? null,
            }
            const NonOperatingDays = activityManagePricing?.activityManageNonOperating
            const PricingTab = {
                commonPricingData, ActivityValidity, NonOperatingDateTime,
                BookingCutOff, IsScheduleActivity, ActivityManageSlots,
                PricingForm, UserPricingForm, ActivityCancellationPolicy,
                NonOperatingDays: {
                    isNonOperatingDates: activityManagePricing?.isNonOperatingDates ? activityManagePricing?.isNonOperatingDates : false,
                    NonOperatingDay: NonOperatingDays
                }
            }

            const retrieveData = { BasicInformationForm, PointAddressForm, PickUpDropPointXML, WhatYouGetList, activityInfo, activityInfoInclusion, PricingTab }
            return retrieveData;
        }
    }
}
//#endregion


const roundValue = (num) => { return Number(Math.round(Number(num))); }

const getAmountOfPercentage = (isPercenatge, basePrice, value) => {
    const amount = isPercenatge ? ((basePrice * value) / 100) : value;
    return roundValue(amount);
}

export const priceCalculation = (
    taxList,
    ActivityManagePaxTypeId = 0,
    PricingTypeId,
    BasePriceString,
    ActivityManageTaxId,
    CommissionString,
    ETMMarkupString,
    orUnit = false
) => {

    // (Base price - Commission) + tax = Net Vendor Amount
    // Vendor Amount + (ETM Markup + Markup tax) = Display Amount

    let priceData = {};
    const BasePrice = BasePriceString ? roundValue(BasePriceString) : BasePriceString;
    const Commission = CommissionString ? roundValue(CommissionString) : CommissionString;
    const ETMMarkup = ETMMarkupString ? roundValue(ETMMarkupString) : ETMMarkupString;

    if (
        !isNullable?.includes(PricingTypeId) &&
        !isNullable?.includes(BasePrice) &&
        !isNullable?.includes(Commission) &&
        !isNullable?.includes(ETMMarkup) &&
        !isNullable?.includes(ActivityManageTaxId)
    ) {
        const isPercentage = PricingTypeId === 1 ? true : false;

        const TaxPercentage = taxList?.find((prev) => prev?.value === ActivityManageTaxId)?.TaxValue;

        const CommissionAmount = getAmountOfPercentage(isPercentage, BasePrice, Commission);
        const BeforeTax = roundValue(BasePrice - CommissionAmount);
        const TaxPercentageAmount = getAmountOfPercentage(true, BeforeTax, TaxPercentage);

        const NetPrice = roundValue(BeforeTax + TaxPercentageAmount);

        const NetMarkupAmount = getAmountOfPercentage(isPercentage, NetPrice, ETMMarkup);
        const MarkupTax = getAmountOfPercentage(true, NetMarkupAmount, TaxPercentage);

        const DisplayPrice = roundValue(NetPrice + NetMarkupAmount + MarkupTax);

        priceData = {
            ActivityManagePaxTypeId,
            BasePrice,
            ActivityManageTaxId,
            TaxPercentage,
            TaxPercentageAmount,
            Commission,
            CommissionAmount,
            ETMMarkup,
            NetMarkupAmount,
            MarkupTax,
            NetPrice, DisplayPrice
        }
        // }
    }
    else {
        priceData = null
    }

    return priceData;
}